import cloneDeep from 'lodash.clonedeep';
import get from 'lodash.get';
import set from 'lodash.set';

import types from './constants';
import reportReducers from '../reducers';
import { states } from '../../values/enums';
import Sorting from '../../util/sorting';

const dirs = Sorting.DIRS
const trackingSorting = new Sorting({
  first_name: dirs.asc,
  last_name: dirs.asc,
  createdAt: dirs.desc,
})

const defaultReducer = (state, action) => (state)

const trackingSort = (state, action) => {
  let next = cloneDeep(state)
  const nextSorts = trackingSorting.run(
    get(next, 'report.data'),
    action.sort,
    get(next, 'sorts', [])
  )
  set(next, 'report.data', nextSorts.data)
  set(next, 'sorts', nextSorts.sorts)
  return next
}

const reportPending = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.PENDING})
  set(next, 'report.activities', []);
  set(next, 'report.data', null)
  return next
}

const reportComplete = (state, action) => {
  let next = cloneDeep(state);
  set(next, 'report.status', {type: states.COMPLETE});
  set(next,'report.activities', action.activities);
  set(next, 'report.data', get(action, 'report.data'));
  set(next,'report.cutoffs',get(action,'report.cutoffs'));
  if(action.report && action.report.data) {
    let nextSorts;
    nextSorts = trackingSorting.run(
      action.report.data, // items to sort
      action.sort,
      get(next, 'sorts', []), // history of previous sorts
      false, // whether to "flip" the sort from it's previous orientation
    )
    set(next, 'report.data', nextSorts.data);
    set(next, 'sorts', nextSorts.sorts);
  }
  return next
}

const reportError = (state, action) => {
  let next = cloneDeep(state)
  set(next, 'report.status', {type: states.ERROR, data: action.error})
  return next
}

const actionReducer = Object.assign({
  [types.TRACKING_SORT]: trackingSort,
  [types.TRACKING_PENDING]: reportPending,
  [types.TRACKING_COMPLETE]: reportComplete,
  [types.TRACKING_ERROR]: reportError,
}, reportReducers);

export default (state = {}, action = {type: null}) => {
  const reducer = actionReducer[action.type] || defaultReducer
  return reducer(state, action)
}